import React, { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';

export default class StringEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
  }

  render() {
    return (
      <input
        className="pwx-string-editor"
        title={this.props.tooltip || this.props.value || ''}
        disabled={this.props.disabled}
        height={this.props.height}
        name={this.props.name}
        onChange={this.onControlValueListener}
        size={this.props.size}
        style={this.props.style}
        type="text"
        value={this.props.value || ''}
        width={this.props.width}
      />
    );
  }

  onControlValueChanged(event) {
    var value = event.currentTarget.value;
    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}